import React from 'react'

const Spinner = (props) => (
  <div className={`spinner ${props.large ? 'spinner-lg' : ''} ${props.className || ''}`} />
)

export default Spinner



// WEBPACK FOOTER //
// ./client/src/components/Spinner.js